import { ROUTES_NAMES } from 'constants/servicenow.routes'
import { Mock } from 'types/global'
import { User } from 'types/user'

export const MocksUserServiceNow:Mock[] = [ 
    { 
        'url': ROUTES_NAMES.user.get.count({"u_user.email": 'qualquercoisa@arrobaemail.com.br'} as User), 
        'method': 'GET', 
        'data': {
            'result': {
                'stats': {
                    'count': '1'
                }
            }
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.all_paginate('0', '10', {"u_user.email": 'qualquercoisa@arrobaemail.com.br'} as User), 
        'method': 'GET', 
        'data': {
            "result": [
                {
                    "sys_id": {
                        "display_value": "dbbfd7961ba1e11060d9426fe54bcbef",
                        "value": "dbbfd7961ba1e11060d9426fe54bcbef"
                    },
                    "u_sector": {
                        "display_value": "Programação Avançada",
                        "link": "https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/00222d8adb25611083948164049619f6",
                        "value": "00222d8adb25611083948164049619f6"
                    },
                    "u_user.email": {
                        "display_value": "qualquercoisa@arrobaemail.com.br",
                        "value": "qualquercoisa@arrobaemail.com.br"
                    },
                    "u_active": {
                        "display_value": "verdadeiro",
                        "value": "true"
                    },
                    "u_location": {
                        "display_value": "PE - Hospital São Marcos",
                        "link": "https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00",
                        "value": "075ab5fe1bfa7810bcd687bfe54bcb00"
                    },
                    "u_profile": {
                        "display_value": "NSP",
                        "value": "nsp"
                    },
                    "u_user": {
                        "display_value": "Indicadores Indicadores",
                        "link": "https://rdsldev.service-now.com/api/now/table/sys_user/eab5db981be3d5104e95a68fe54bcbbe",
                        "value": "eab5db981be3d5104e95a68fe54bcbbe"
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.count({u_sector: '00222d8adb25611083948164049619f6'} as User), 
        'method': 'GET', 
        'data': {
            'result': {
                'stats': {
                    'count': '1'
                }
            }
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.all_paginate('0', '10', {u_sector: '00222d8adb25611083948164049619f6'} as User), 
        'method': 'GET', 
        'data': {
            "result": [
                {
                    "sys_id": {
                        "display_value": "dbbfd7961ba1e11060d9426fe54bcbef",
                        "value": "dbbfd7961ba1e11060d9426fe54bcbef"
                    },
                    "u_sector": {
                        "display_value": "Programação Avançada",
                        "link": "https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/00222d8adb25611083948164049619f6",
                        "value": "00222d8adb25611083948164049619f6"
                    },
                    "u_user.email": {
                        "display_value": "qualquercoisa@arrobaemail.com.br",
                        "value": "qualquercoisa@arrobaemail.com.br"
                    },
                    "u_active": {
                        "display_value": "verdadeiro",
                        "value": "true"
                    },
                    "u_location": {
                        "display_value": "PE - Hospital São Marcos",
                        "link": "https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00",
                        "value": "075ab5fe1bfa7810bcd687bfe54bcb00"
                    },
                    "u_profile": {
                        "display_value": "NSP",
                        "value": "nsp"
                    },
                    "u_user": {
                        "display_value": "Indicadores Indicadores",
                        "link": "https://rdsldev.service-now.com/api/now/table/sys_user/eab5db981be3d5104e95a68fe54bcbbe",
                        "value": "eab5db981be3d5104e95a68fe54bcbbe"
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.all_paginate('0', '10', {u_profile: 'admin'} as User), 
        'method': 'GET', 
        'data':{
            'result': [
                {
                    'sys_id': {
                        'display_value': '0dd3ea9cdb7d2910839481640496194f',
                        'value': '0dd3ea9cdb7d2910839481640496194f'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Fabiane Freitas de Oliveira',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/679f23dc1b6f95106adcea8ce54bcb69',
                        'value': '679f23dc1b6f95106adcea8ce54bcb69'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '1662a2981b79a91060d9426fe54bcb0b',
                        'value': '1662a2981b79a91060d9426fe54bcb0b'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Danielle Ayanna Nascimento Alves',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/776e57c81b06f4106adcea8ce54bcba5',
                        'value': '776e57c81b06f4106adcea8ce54bcba5'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '3411ee181b79a91060d9426fe54bcb8e',
                        'value': '3411ee181b79a91060d9426fe54bcb8e'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Damiles Ferreira Cruz',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/534ea40d1b235d104e95a68fe54bcb5e',
                        'value': '534ea40d1b235d104e95a68fe54bcb5e'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '4cce9ecadb2961108394816404961975',
                        'value': '4cce9ecadb2961108394816404961975'
                    },
                    'u_sector': {
                        'display_value': 'Tecnologia da Informação (TI)',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/054333e9dba12110839481640496192a',
                        'value': '054333e9dba12110839481640496192a'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'falso',
                        'value': 'false'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Ana Alice Monteiro',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/1791070c1b46f4104e95a68fe54bcb99',
                        'value': '1791070c1b46f4104e95a68fe54bcb99'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '5091ee181b79a91060d9426fe54bcb95',
                        'value': '5091ee181b79a91060d9426fe54bcb95'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'emailfake@ponto.com.br',
                        'value': 'emailfake@ponto.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Daniel Pinto',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/cd2687cc1b86f4104e95a68fe54bcbb9',
                        'value': 'cd2687cc1b86f4104e95a68fe54bcbb9'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '534dded01b79a91060d9426fe54bcb0e',
                        'value': '534dded01b79a91060d9426fe54bcb0e'
                    },
                    'u_sector': {
                        'display_value': 'Tecnologia da Informação (TI)',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/054333e9dba12110839481640496192a',
                        'value': '054333e9dba12110839481640496192a'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Alberto Alves Fernandes',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/a70fe94e1bd791906adcea8ce54bcb79',
                        'value': 'a70fe94e1bd791906adcea8ce54bcb79'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '53a2a65cdb7d291083948164049619ec',
                        'value': '53a2a65cdb7d291083948164049619ec'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'David Santos Belo',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/6e89d7c41bc2f4106adcea8ce54bcb52',
                        'value': '6e89d7c41bc2f4106adcea8ce54bcb52'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '5844e2dcdb7d29108394816404961951',
                        'value': '5844e2dcdb7d29108394816404961951'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Fernanda Aparecida Salatiel Pedro',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/f7a038c51b635d104e95a68fe54bcbdd',
                        'value': 'f7a038c51b635d104e95a68fe54bcbdd'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '5b53e29cdb7d2910839481640496194c',
                        'value': '5b53e29cdb7d2910839481640496194c'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Erika Oliveira Alves',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/f87ed7c81b06f4106adcea8ce54bcbaf',
                        'value': 'f87ed7c81b06f4106adcea8ce54bcbaf'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '5def52d8db7d291083948164049619fb',
                        'value': '5def52d8db7d291083948164049619fb'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'amanda.cmachado amanda.cmachado',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/c45e2cc11b6b1d106adcea8ce54bcbb5',
                        'value': 'c45e2cc11b6b1d106adcea8ce54bcbb5'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.all_paginate('1', '10', {u_profile: 'admin'} as User), 
        'method': 'GET', 
        'data':{
            'result': [
                {
                    'sys_id': {
                        'display_value': '65e2225cdb7d291083948164049619aa',
                        'value': '65e2225cdb7d291083948164049619aa'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Deborah Simões',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/84f10f4c1b46f4104e95a68fe54bcb99',
                        'value': '84f10f4c1b46f4104e95a68fe54bcb99'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '6a802ad8db7d2910839481640496194f',
                        'value': '6a802ad8db7d2910839481640496194f'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Camila Leopoldina Do Nascimento Bezerra',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/63585f881bcaf4104e95a68fe54bcb11',
                        'value': '63585f881bcaf4104e95a68fe54bcb11'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '9773aad81b79a91060d9426fe54bcb90',
                        'value': '9773aad81b79a91060d9426fe54bcb90'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Erika Correa Vrandecic',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/4985d2961bdcd9104e95a68fe54bcb71',
                        'value': '4985d2961bdcd9104e95a68fe54bcb71'
                    }
                },
                {
                    'sys_id': {
                        'display_value': 'a6a36ed81b79a91060d9426fe54bcbc6',
                        'value': 'a6a36ed81b79a91060d9426fe54bcbc6'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Fernanda Trindade Oliveira Silva',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/576e17c81b06f4106adcea8ce54bcbde',
                        'value': '576e17c81b06f4106adcea8ce54bcbde'
                    }
                },
                {
                    'sys_id': {
                        'display_value': 'b6142a1c1b79a91060d9426fe54bcb8d',
                        'value': 'b6142a1c1b79a91060d9426fe54bcb8d'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Fernanda Mirelly Freitas Menezes',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/bc7ed7c81b06f4106adcea8ce54bcbed',
                        'value': 'bc7ed7c81b06f4106adcea8ce54bcbed'
                    }
                },
                {
                    'sys_id': {
                        'display_value': 'bd64a2dcdb7d291083948164049619e6',
                        'value': 'bd64a2dcdb7d291083948164049619e6'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Graziela Carvalho Da Mota',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/cebe93041b4ef4104e95a68fe54bcb28',
                        'value': 'cebe93041b4ef4104e95a68fe54bcb28'
                    }
                },
                {
                    'sys_id': {
                        'display_value': 'cca46e9cdb7d29108394816404961923',
                        'value': 'cca46e9cdb7d29108394816404961923'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Guilherme Bueno da Silva',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/a838458d1baf1d106adcea8ce54bcbeb',
                        'value': 'a838458d1baf1d106adcea8ce54bcbeb'
                    }
                },
                {
                    'sys_id': {
                        'display_value': 'dae0661cdb7d2910839481640496195f',
                        'value': 'dae0661cdb7d2910839481640496195f'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Caroline Dos Anjos Dourado',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/36589f801bc2f4106adcea8ce54bcb4d',
                        'value': '36589f801bc2f4106adcea8ce54bcb4d'
                    }
                },
                {
                    'sys_id': {
                        'display_value': 'db452a5c1b79a91060d9426fe54bcbe2',
                        'value': 'db452a5c1b79a91060d9426fe54bcbe2'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'INDIARA CAMPOS TAVARES DE SANTANA',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/807541c11baf1d106adcea8ce54bcb30',
                        'value': '807541c11baf1d106adcea8ce54bcb30'
                    }
                },
                {
                    'sys_id': {
                        'display_value': 'e71326d81b79a91060d9426fe54bcb31',
                        'value': 'e71326d81b79a91060d9426fe54bcb31'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Elvira Danielle Martins Sousa',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/879f57001b46f4106adcea8ce54bcb46',
                        'value': '879f57001b46f4106adcea8ce54bcb46'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.all_paginate('2', '10', {u_profile: 'admin'} as User), 
        'method': 'GET', 
        'data':{
            'result': [
                {
                    'sys_id': {
                        'display_value': 'ee61a2581b79a91060d9426fe54bcb9f',
                        'value': 'ee61a2581b79a91060d9426fe54bcb9f'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Daniel Favarão Del Negro',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/597403801b8eb4106adcea8ce54bcb2b',
                        'value': '597403801b8eb4106adcea8ce54bcb2b'
                    }
                },
                {
                    'sys_id': {
                        'display_value': 'f1ddc61cdb3d2910839481640496197d',
                        'value': 'f1ddc61cdb3d2910839481640496197d'
                    },
                    'u_sector': {
                        'display_value': 'Tecnologia da Informação (TI)',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/054333e9dba12110839481640496192a',
                        'value': '054333e9dba12110839481640496192a'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Ana CLAUDIA FERNANDES',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/8418f68c1bcab4106adcea8ce54bcbb0',
                        'value': '8418f68c1bcab4106adcea8ce54bcbb0'
                    }
                },
                {
                    'sys_id': {
                        'display_value': 'f9402ad41b79a91060d9426fe54bcbca',
                        'value': 'f9402ad41b79a91060d9426fe54bcbca'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Ana Marilia Dos Santos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/7dbe1b0c1b06f4106adcea8ce54bcbb0',
                        'value': '7dbe1b0c1b06f4106adcea8ce54bcbb0'
                    }
                },
                {
                    'sys_id': {
                        'display_value': 'f9c46e1c1b79a91060d9426fe54bcb79',
                        'value': 'f9c46e1c1b79a91060d9426fe54bcb79'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Gustavo Ferreira Araújo',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/0593078c1b4eb4106adcea8ce54bcb2b',
                        'value': '0593078c1b4eb4106adcea8ce54bcb2b'
                    }
                },
                {
                    'sys_id': {
                        'display_value': 'ff15e6dcdb7d291083948164049619c1',
                        'value': 'ff15e6dcdb7d291083948164049619c1'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Humberto Cunha Castro',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/125143441b4eb4106adcea8ce54bcb72',
                        'value': '125143441b4eb4106adcea8ce54bcb72'
                    }
                },
                {
                    'sys_id': {
                        'display_value': 'fff2ae581b79a91060d9426fe54bcbb5',
                        'value': 'fff2ae581b79a91060d9426fe54bcbb5'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrador',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Ektor Correa Vrandecic',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/898592521b58d9106adcea8ce54bcb21',
                        'value': '898592521b58d9106adcea8ce54bcb21'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.count({u_profile: 'admin'} as User), 
        'method': 'GET', 
        'data': {
            'result': {
                'stats': {
                    'count': '26'
                }
            }
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.count(undefined), 
        'method': 'GET', 
        'data': {
            'result': {
                'stats': {
                    'count': '33'
                }
            }
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.by_attribute_value('u_user.email','emailparateste@email.com.br'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'sys_id': {
                        'display_value': 'dbbfd7961ba1e11060d9426fe54bcbef',
                        'value': 'dbbfd7961ba1e11060d9426fe54bcbef'
                    },
                    'u_sector': {
                        'display_value': 'Recepção',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/75637fa9dba12110839481640496191c',
                        'value': '75637fa9dba12110839481640496191c'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'verdadeiro',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'NSP',
                        'value': 'nsp'
                    },
                    'u_user': {
                        'display_value': 'Indicadores Indicadores',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/eab5db981be3d5104e95a68fe54bcbbe',
                        'value': 'eab5db981be3d5104e95a68fe54bcbbe'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.all_paginate('0', '10'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'sys_id': {
                        'display_value': 'dbbfd7961ba1e11060d9426fe54bcbef',
                        'value': 'dbbfd7961ba1e11060d9426fe54bcbef'
                    },
                    'u_sector': {
                        'display_value': 'Tecnologia da Informação (TI)',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/054333e9dba12110839481640496192a',
                        'value': '054333e9dba12110839481640496192a'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'NSP',
                        'value': 'nsp'
                    },
                    'u_user': {
                        'display_value': 'Indicadores Indicadores',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/eab5db981be3d5104e95a68fe54bcbbe',
                        'value': 'eab5db981be3d5104e95a68fe54bcbbe'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '0dd3ea9cdb7d2910839481640496194f',
                        'value': '0dd3ea9cdb7d2910839481640496194f'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Fabiane Freitas de Oliveira',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/679f23dc1b6f95106adcea8ce54bcb69',
                        'value': '679f23dc1b6f95106adcea8ce54bcb69'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '1662a2981b79a91060d9426fe54bcb0b',
                        'value': '1662a2981b79a91060d9426fe54bcb0b'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Danielle Ayanna Nascimento Alves',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/776e57c81b06f4106adcea8ce54bcba5',
                        'value': '776e57c81b06f4106adcea8ce54bcba5'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '1e93b3e9dba1211083948164049619c9',
                        'value': '1e93b3e9dba1211083948164049619c9'
                    },
                    'u_sector': {
                        'display_value': 'Recepção',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/75637fa9dba12110839481640496191c',
                        'value': '75637fa9dba12110839481640496191c'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Daniel Aguiar Gallante Reis',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/ff96929d1b9f09504e95a68fe54bcbef',
                        'value': 'ff96929d1b9f09504e95a68fe54bcbef'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '3411ee181b79a91060d9426fe54bcb8e',
                        'value': '3411ee181b79a91060d9426fe54bcb8e'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Damiles Ferreira Cruz',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/534ea40d1b235d104e95a68fe54bcb5e',
                        'value': '534ea40d1b235d104e95a68fe54bcb5e'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '4cce9ecadb2961108394816404961975',
                        'value': '4cce9ecadb2961108394816404961975'
                    },
                    'u_sector': {
                        'display_value': 'Tecnologia da Informação (TI)',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/054333e9dba12110839481640496192a',
                        'value': '054333e9dba12110839481640496192a'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Ana Alice Monteiro',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/1791070c1b46f4104e95a68fe54bcb99',
                        'value': '1791070c1b46f4104e95a68fe54bcb99'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '5091ee181b79a91060d9426fe54bcb95',
                        'value': '5091ee181b79a91060d9426fe54bcb95'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'emailfake@ponto.com.br',
                        'value': 'emailfake@ponto.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Daniel Pinto',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/cd2687cc1b86f4104e95a68fe54bcbb9',
                        'value': 'cd2687cc1b86f4104e95a68fe54bcbb9'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '534dded01b79a91060d9426fe54bcb0e',
                        'value': '534dded01b79a91060d9426fe54bcb0e'
                    },
                    'u_sector': {
                        'display_value': 'Tecnologia da Informação (TI)',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/054333e9dba12110839481640496192a',
                        'value': '054333e9dba12110839481640496192a'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Alberto Alves Fernandes',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/a70fe94e1bd791906adcea8ce54bcb79',
                        'value': 'a70fe94e1bd791906adcea8ce54bcb79'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '53a2a65cdb7d291083948164049619ec',
                        'value': '53a2a65cdb7d291083948164049619ec'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'David Santos Belo',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/6e89d7c41bc2f4106adcea8ce54bcb52',
                        'value': '6e89d7c41bc2f4106adcea8ce54bcb52'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '5844e2dcdb7d29108394816404961951',
                        'value': '5844e2dcdb7d29108394816404961951'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Fernanda Aparecida Salatiel Pedro',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/f7a038c51b635d104e95a68fe54bcbdd',
                        'value': 'f7a038c51b635d104e95a68fe54bcbdd'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.all_paginate('1', '10'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'sys_id': {
                        'display_value': '0dd3ea9cdb7d2910839481640496194f',
                        'value': '0dd3ea9cdb7d2910839481640496194f'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Fabiane Freitas de Oliveira',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/679f23dc1b6f95106adcea8ce54bcb69',
                        'value': '679f23dc1b6f95106adcea8ce54bcb69'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '1662a2981b79a91060d9426fe54bcb0b',
                        'value': '1662a2981b79a91060d9426fe54bcb0b'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Danielle Ayanna Nascimento Alves',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/776e57c81b06f4106adcea8ce54bcba5',
                        'value': '776e57c81b06f4106adcea8ce54bcba5'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '1e93b3e9dba1211083948164049619c9',
                        'value': '1e93b3e9dba1211083948164049619c9'
                    },
                    'u_sector': {
                        'display_value': 'Recepção',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/75637fa9dba12110839481640496191c',
                        'value': '75637fa9dba12110839481640496191c'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Daniel Aguiar Gallante Reis',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/ff96929d1b9f09504e95a68fe54bcbef',
                        'value': 'ff96929d1b9f09504e95a68fe54bcbef'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '3411ee181b79a91060d9426fe54bcb8e',
                        'value': '3411ee181b79a91060d9426fe54bcb8e'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Damiles Ferreira Cruz',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/534ea40d1b235d104e95a68fe54bcb5e',
                        'value': '534ea40d1b235d104e95a68fe54bcb5e'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '4cce9ecadb2961108394816404961975',
                        'value': '4cce9ecadb2961108394816404961975'
                    },
                    'u_sector': {
                        'display_value': 'Tecnologia da Informação (TI)',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/054333e9dba12110839481640496192a',
                        'value': '054333e9dba12110839481640496192a'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Ana Alice Monteiro',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/1791070c1b46f4104e95a68fe54bcb99',
                        'value': '1791070c1b46f4104e95a68fe54bcb99'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '5091ee181b79a91060d9426fe54bcb95',
                        'value': '5091ee181b79a91060d9426fe54bcb95'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'emailfake@ponto.com.br',
                        'value': 'emailfake@ponto.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Daniel Pinto',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/cd2687cc1b86f4104e95a68fe54bcbb9',
                        'value': 'cd2687cc1b86f4104e95a68fe54bcbb9'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '534dded01b79a91060d9426fe54bcb0e',
                        'value': '534dded01b79a91060d9426fe54bcb0e'
                    },
                    'u_sector': {
                        'display_value': 'Tecnologia da Informação (TI)',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/054333e9dba12110839481640496192a',
                        'value': '054333e9dba12110839481640496192a'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Alberto Alves Fernandes',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/a70fe94e1bd791906adcea8ce54bcb79',
                        'value': 'a70fe94e1bd791906adcea8ce54bcb79'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '53a2a65cdb7d291083948164049619ec',
                        'value': '53a2a65cdb7d291083948164049619ec'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'David Santos Belo',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/6e89d7c41bc2f4106adcea8ce54bcb52',
                        'value': '6e89d7c41bc2f4106adcea8ce54bcb52'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '5844e2dcdb7d29108394816404961951',
                        'value': '5844e2dcdb7d29108394816404961951'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Fernanda Aparecida Salatiel Pedro',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/f7a038c51b635d104e95a68fe54bcbdd',
                        'value': 'f7a038c51b635d104e95a68fe54bcbdd'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '5b53e29cdb7d2910839481640496194c',
                        'value': '5b53e29cdb7d2910839481640496194c'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Erika Oliveira Alves',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/f87ed7c81b06f4106adcea8ce54bcbaf',
                        'value': 'f87ed7c81b06f4106adcea8ce54bcbaf'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.all_paginate('2', '10'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'sys_id': {
                        'display_value': '1662a2981b79a91060d9426fe54bcb0b',
                        'value': '1662a2981b79a91060d9426fe54bcb0b'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Danielle Ayanna Nascimento Alves',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/776e57c81b06f4106adcea8ce54bcba5',
                        'value': '776e57c81b06f4106adcea8ce54bcba5'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '1e93b3e9dba1211083948164049619c9',
                        'value': '1e93b3e9dba1211083948164049619c9'
                    },
                    'u_sector': {
                        'display_value': 'Recepção',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/75637fa9dba12110839481640496191c',
                        'value': '75637fa9dba12110839481640496191c'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Daniel Aguiar Gallante Reis',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/ff96929d1b9f09504e95a68fe54bcbef',
                        'value': 'ff96929d1b9f09504e95a68fe54bcbef'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '3411ee181b79a91060d9426fe54bcb8e',
                        'value': '3411ee181b79a91060d9426fe54bcb8e'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Damiles Ferreira Cruz',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/534ea40d1b235d104e95a68fe54bcb5e',
                        'value': '534ea40d1b235d104e95a68fe54bcb5e'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '4cce9ecadb2961108394816404961975',
                        'value': '4cce9ecadb2961108394816404961975'
                    },
                    'u_sector': {
                        'display_value': 'Tecnologia da Informação (TI)',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/054333e9dba12110839481640496192a',
                        'value': '054333e9dba12110839481640496192a'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Ana Alice Monteiro',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/1791070c1b46f4104e95a68fe54bcb99',
                        'value': '1791070c1b46f4104e95a68fe54bcb99'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '5091ee181b79a91060d9426fe54bcb95',
                        'value': '5091ee181b79a91060d9426fe54bcb95'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'emailfake@ponto.com.br',
                        'value': 'emailfake@ponto.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Daniel Pinto',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/cd2687cc1b86f4104e95a68fe54bcbb9',
                        'value': 'cd2687cc1b86f4104e95a68fe54bcbb9'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '534dded01b79a91060d9426fe54bcb0e',
                        'value': '534dded01b79a91060d9426fe54bcb0e'
                    },
                    'u_sector': {
                        'display_value': 'Tecnologia da Informação (TI)',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/054333e9dba12110839481640496192a',
                        'value': '054333e9dba12110839481640496192a'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Alberto Alves Fernandes',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/a70fe94e1bd791906adcea8ce54bcb79',
                        'value': 'a70fe94e1bd791906adcea8ce54bcb79'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '53a2a65cdb7d291083948164049619ec',
                        'value': '53a2a65cdb7d291083948164049619ec'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'David Santos Belo',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/6e89d7c41bc2f4106adcea8ce54bcb52',
                        'value': '6e89d7c41bc2f4106adcea8ce54bcb52'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '5844e2dcdb7d29108394816404961951',
                        'value': '5844e2dcdb7d29108394816404961951'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Fernanda Aparecida Salatiel Pedro',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/f7a038c51b635d104e95a68fe54bcbdd',
                        'value': 'f7a038c51b635d104e95a68fe54bcbdd'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '5b53e29cdb7d2910839481640496194c',
                        'value': '5b53e29cdb7d2910839481640496194c'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Erika Oliveira Alves',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/f87ed7c81b06f4106adcea8ce54bcbaf',
                        'value': 'f87ed7c81b06f4106adcea8ce54bcbaf'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '5def52d8db7d291083948164049619fb',
                        'value': '5def52d8db7d291083948164049619fb'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'amanda.cmachado amanda.cmachado',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/c45e2cc11b6b1d106adcea8ce54bcbb5',
                        'value': 'c45e2cc11b6b1d106adcea8ce54bcbb5'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.all_paginate('3', '10'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'sys_id': {
                        'display_value': '1e93b3e9dba1211083948164049619c9',
                        'value': '1e93b3e9dba1211083948164049619c9'
                    },
                    'u_sector': {
                        'display_value': 'Recepção',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/75637fa9dba12110839481640496191c',
                        'value': '75637fa9dba12110839481640496191c'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Daniel Aguiar Gallante Reis',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/ff96929d1b9f09504e95a68fe54bcbef',
                        'value': 'ff96929d1b9f09504e95a68fe54bcbef'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '3411ee181b79a91060d9426fe54bcb8e',
                        'value': '3411ee181b79a91060d9426fe54bcb8e'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Damiles Ferreira Cruz',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/534ea40d1b235d104e95a68fe54bcb5e',
                        'value': '534ea40d1b235d104e95a68fe54bcb5e'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '4cce9ecadb2961108394816404961975',
                        'value': '4cce9ecadb2961108394816404961975'
                    },
                    'u_sector': {
                        'display_value': 'Tecnologia da Informação (TI)',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/054333e9dba12110839481640496192a',
                        'value': '054333e9dba12110839481640496192a'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Ana Alice Monteiro',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/1791070c1b46f4104e95a68fe54bcb99',
                        'value': '1791070c1b46f4104e95a68fe54bcb99'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '5091ee181b79a91060d9426fe54bcb95',
                        'value': '5091ee181b79a91060d9426fe54bcb95'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'emailfake@ponto.com.br',
                        'value': 'emailfake@ponto.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Daniel Pinto',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/cd2687cc1b86f4104e95a68fe54bcbb9',
                        'value': 'cd2687cc1b86f4104e95a68fe54bcbb9'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '534dded01b79a91060d9426fe54bcb0e',
                        'value': '534dded01b79a91060d9426fe54bcb0e'
                    },
                    'u_sector': {
                        'display_value': 'Tecnologia da Informação (TI)',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/054333e9dba12110839481640496192a',
                        'value': '054333e9dba12110839481640496192a'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Alberto Alves Fernandes',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/a70fe94e1bd791906adcea8ce54bcb79',
                        'value': 'a70fe94e1bd791906adcea8ce54bcb79'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '53a2a65cdb7d291083948164049619ec',
                        'value': '53a2a65cdb7d291083948164049619ec'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'David Santos Belo',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/6e89d7c41bc2f4106adcea8ce54bcb52',
                        'value': '6e89d7c41bc2f4106adcea8ce54bcb52'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '5844e2dcdb7d29108394816404961951',
                        'value': '5844e2dcdb7d29108394816404961951'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Fernanda Aparecida Salatiel Pedro',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/f7a038c51b635d104e95a68fe54bcbdd',
                        'value': 'f7a038c51b635d104e95a68fe54bcbdd'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '5b53e29cdb7d2910839481640496194c',
                        'value': '5b53e29cdb7d2910839481640496194c'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Erika Oliveira Alves',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/f87ed7c81b06f4106adcea8ce54bcbaf',
                        'value': 'f87ed7c81b06f4106adcea8ce54bcbaf'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '5def52d8db7d291083948164049619fb',
                        'value': '5def52d8db7d291083948164049619fb'
                    },
                    'u_sector': {
                        'display_value': 'Enfermaria',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/2ef780621b65e11060d9426fe54bcbee',
                        'value': '2ef780621b65e11060d9426fe54bcbee'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'amanda.cmachado amanda.cmachado',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/c45e2cc11b6b1d106adcea8ce54bcbb5',
                        'value': 'c45e2cc11b6b1d106adcea8ce54bcbb5'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '61b704221b65e11060d9426fe54bcb38',
                        'value': '61b704221b65e11060d9426fe54bcb38'
                    },
                    'u_sector': {
                        'display_value': 'Recepção',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/75637fa9dba12110839481640496191c',
                        'value': '75637fa9dba12110839481640496191c'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Location Manager',
                        'value': 'location_manager'
                    },
                    'u_user': {
                        'display_value': 'DAIANA CARVALHO',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/de22c7081b4eb4106adcea8ce54bcb84',
                        'value': 'de22c7081b4eb4106adcea8ce54bcb84'
                    }
                }
            ]
        }
    },    
    { 
        'url': ROUTES_NAMES.user.post.create, 
        'method': 'POST', 
        'data': {}
    },
    { 
        'url': ROUTES_NAMES.user.put.update('eab5db981be3d5104e95a68fe54bcbbe'), 
        'method': 'PUT', 
        'data': {
            'result': {
                'sys_id': {
                    'display_value': 'eab5db981be3d5104e95a68fe54bcbbe',
                    'value': 'eab5db981be3d5104e95a68fe54bcbbe'
                },
                'u_sector': {
                    'display_value': 'Recepção',
                    'value': '75637fa9dba12110839481640496191c'
                },
                'u_active': {
                    'display_value': 'true',
                    'value': 'true'
                },
                'u_user.email': {
                    'display_value': 'qualquercoisa@arrobaemail.com.br',
                    'value': 'qualquercoisa@arrobaemail.com.br'
                },
                'u_user.name': {
                    'display_value': 'Indicadores Indicadores',
                    'value': 'Indicadores Indicadores'
                },
                'u_location': {
                    'display_value': 'PE - Hospital São Marcos',
                    'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                },
                'u_profile': {
                    'display_value': 'Administrator',
                    'value': 'admin'
                }
            }
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.byid('ff96929d1b9f09504e95a68fe54bcbef'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'sys_id': {
                        'display_value': '1e93b3e9dba1211083948164049619c9',
                        'value': '1e93b3e9dba1211083948164049619c9'
                    },
                    'u_sector': {
                        'display_value': 'Recepção',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/75637fa9dba12110839481640496191c',
                        'value': '75637fa9dba12110839481640496191c'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'SP - Hospital Campinas',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/0dc18b6d1be45d504e95a68fe54bcb1a',
                        'value': '0dc18b6d1be45d504e95a68fe54bcb1a'
                    },
                    'u_profile': {
                        'display_value': 'Location Manager',
                        'value': 'location_manager'
                    },
                    'u_user': {
                        'display_value': 'Daniel Aguiar Gallante Reis',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/ff96929d1b9f09504e95a68fe54bcbef',
                        'value': 'ff96929d1b9f09504e95a68fe54bcbef'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.byid('4cce9ecadb2961108394816404961975'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'sys_id': {
                        'display_value': '4cce9ecadb2961108394816404961975',
                        'value': '4cce9ecadb2961108394816404961975'
                    },
                    'u_sector': {
                        'display_value': 'Tecnologia da Informação (TI)',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/054333e9dba12110839481640496192a',
                        'value': '054333e9dba12110839481640496192a'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Ana Alice Monteiro',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/1791070c1b46f4104e95a68fe54bcb99',
                        'value': '1791070c1b46f4104e95a68fe54bcb99'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.byid('61b704221b65e11060d9426fe54bcb38'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'sys_id': {
                        'display_value': '61b704221b65e11060d9426fe54bcb38',
                        'value': '61b704221b65e11060d9426fe54bcb38'
                    },
                    'u_sector': {
                        'display_value': 'Recepção',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/75637fa9dba12110839481640496191c',
                        'value': '75637fa9dba12110839481640496191c'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Location Manager',
                        'value': 'location_manager'
                    },
                    'u_user': {
                        'display_value': 'DAIANA CARVALHO',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/de22c7081b4eb4106adcea8ce54bcb84',
                        'value': 'de22c7081b4eb4106adcea8ce54bcb84'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.byid('8c5ee40d1b235d104e95a68fe54bcbad'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'sys_id': {
                        'display_value': 'b81e1ac21bed611060d9426fe54bcba2',
                        'value': 'b81e1ac21bed611060d9426fe54bcba2'
                    },
                    'u_sector': {
                        'display_value': 'Tecnologia da Informação (TI)',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/054333e9dba12110839481640496192a',
                        'value': '054333e9dba12110839481640496192a'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Diego Costa da Silva',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/8c5ee40d1b235d104e95a68fe54bcbad',
                        'value': '8c5ee40d1b235d104e95a68fe54bcbad'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.byid('dbbfd7961ba1e11060d9426fe54bcbef'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'sys_id': {
                        'display_value': 'dbbfd7961ba1e11060d9426fe54bcbef',
                        'value': 'dbbfd7961ba1e11060d9426fe54bcbef'
                    },
                    'u_sector': {
                        'display_value': 'Tecnologia da Informação (TI)',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/054333e9dba12110839481640496192a',
                        'value': '054333e9dba12110839481640496192a'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'NSP',
                        'value': 'nsp'
                    },
                    'u_user': {
                        'display_value': 'Indicadores Indicadores',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/eab5db981be3d5104e95a68fe54bcbbe',
                        'value': 'eab5db981be3d5104e95a68fe54bcbbe'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.byid('eab5db981be3d5104e95a68fe54bcbbe'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'sys_id': {
                        'display_value': 'eab5db981be3d5104e95a68fe54bcbbe',
                        'value': 'eab5db981be3d5104e95a68fe54bcbbe'
                    },
                    'u_sector': {
                        'display_value': 'Tecnologia da Informação (TI)',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/054333e9dba12110839481640496192a',
                        'value': '054333e9dba12110839481640496192a'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'NSP',
                        'value': 'nsp'
                    },
                    'u_user': {
                        'display_value': 'Indicadores Indicadores',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/eab5db981be3d5104e95a68fe54bcbbe',
                        'value': 'eab5db981be3d5104e95a68fe54bcbbe'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.byid('e5b377e9dba121108394816404961928'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'sys_id': {
                        'display_value': 'e5b377e9dba121108394816404961928',
                        'value': 'e5b377e9dba121108394816404961928'
                    },
                    'u_sector': {
                        'display_value': 'Recepção',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/75637fa9dba12110839481640496191c',
                        'value': '75637fa9dba12110839481640496191c'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    },
                    'u_location': {
                        'display_value': 'SP - Hosp SL - Anália Franco',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/df5ab5fe1bfa7810bcd687bfe54bcbc5',
                        'value': 'df5ab5fe1bfa7810bcd687bfe54bcbc5'
                    },
                    'u_profile': {
                        'display_value': 'Location Quality',
                        'value': 'location_qa'
                    },
                    'u_user': {
                        'display_value': 'Murilo Cordeiro',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/f6729f1c1b6b95106adcea8ce54bcb59',
                        'value': 'f6729f1c1b6b95106adcea8ce54bcb59'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.byid('f445676edbe5e1108394816404961901'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'sys_id': {
                        'display_value': 'f445676edbe5e1108394816404961901',
                        'value': 'f445676edbe5e1108394816404961901'
                    },
                    'u_sector': {
                        'display_value': 'Gerência',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/d72d983d1b65211060d9426fe54bcbff',
                        'value': 'd72d983d1b65211060d9426fe54bcbff'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Location Manager',
                        'value': 'location_manager'
                    },
                    'u_user': {
                        'display_value': 'Guilherme Oliveira de Carvalho',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/e1b2ce641b8099504e95a68fe54bcbbc',
                        'value': 'e1b2ce641b8099504e95a68fe54bcbbc'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.byid(''), 
        'method': 'GET', 
        'data': {}
    },
    { 
        'url': ROUTES_NAMES.user.get.all, 
        'method': 'GET', 
        'data':  {
            'result': [
                {
                    'sys_id': {
                        'display_value': '1e93b3e9dba1211083948164049619c9',
                        'value': '1e93b3e9dba1211083948164049619c9'
                    },
                    'u_sector': {
                        'display_value': 'Recepção',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/75637fa9dba12110839481640496191c',
                        'value': '75637fa9dba12110839481640496191c'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Daniel Aguiar Gallante Reis',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/ff96929d1b9f09504e95a68fe54bcbef',
                        'value': 'ff96929d1b9f09504e95a68fe54bcbef'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '4cce9ecadb2961108394816404961975',
                        'value': '4cce9ecadb2961108394816404961975'
                    },
                    'u_sector': {
                        'display_value': 'Tecnologia da Informação (TI) 123',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/054333e9dba12110839481640496192a',
                        'value': '054333e9dba12110839481640496192a'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Ana Alice Monteiro',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/1791070c1b46f4104e95a68fe54bcb99',
                        'value': '1791070c1b46f4104e95a68fe54bcb99'
                    }
                },
                {
                    'sys_id': {
                        'display_value': '61b704221b65e11060d9426fe54bcb38',
                        'value': '61b704221b65e11060d9426fe54bcb38'
                    },
                    'u_sector': {
                        'display_value': 'Recepção',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/75637fa9dba12110839481640496191c',
                        'value': '75637fa9dba12110839481640496191c'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Location Manager',
                        'value': 'location_manager'
                    },
                    'u_user': {
                        'display_value': 'DAIANA CARVALHO',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/de22c7081b4eb4106adcea8ce54bcb84',
                        'value': 'de22c7081b4eb4106adcea8ce54bcb84'
                    }
                },
                {
                    'sys_id': {
                        'display_value': 'b81e1ac21bed611060d9426fe54bcba2',
                        'value': 'b81e1ac21bed611060d9426fe54bcba2'
                    },
                    'u_sector': {
                        'display_value': 'Tecnologia da Informação (TI) 123',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/054333e9dba12110839481640496192a',
                        'value': '054333e9dba12110839481640496192a'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Administrator',
                        'value': 'admin'
                    },
                    'u_user': {
                        'display_value': 'Diego Costa da Silva',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/8c5ee40d1b235d104e95a68fe54bcbad',
                        'value': '8c5ee40d1b235d104e95a68fe54bcbad'
                    }
                },
                {
                    'sys_id': {
                        'display_value': 'dbbfd7961ba1e11060d9426fe54bcbef',
                        'value': 'dbbfd7961ba1e11060d9426fe54bcbef'
                    },
                    'u_sector': {
                        'display_value': 'Recepção',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/75637fa9dba12110839481640496191c',
                        'value': '75637fa9dba12110839481640496191c'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'NSP',
                        'value': 'nsp'
                    },
                    'u_user': {
                        'display_value': 'Indicadores Indicadores',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/eab5db981be3d5104e95a68fe54bcbbe',
                        'value': 'eab5db981be3d5104e95a68fe54bcbbe'
                    }
                },
                {
                    'sys_id': {
                        'display_value': 'e5b377e9dba121108394816404961928',
                        'value': 'e5b377e9dba121108394816404961928'
                    },
                    'u_sector': {
                        'display_value': 'Recepção',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/75637fa9dba12110839481640496191c',
                        'value': '75637fa9dba12110839481640496191c'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    },
                    'u_location': {
                        'display_value': 'SP - Hosp SL - Anália Franco',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/df5ab5fe1bfa7810bcd687bfe54bcbc5',
                        'value': 'df5ab5fe1bfa7810bcd687bfe54bcbc5'
                    },
                    'u_profile': {
                        'display_value': 'Location Quality',
                        'value': 'location_qa'
                    },
                    'u_user': {
                        'display_value': 'Murilo Cordeiro',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/f6729f1c1b6b95106adcea8ce54bcb59',
                        'value': 'f6729f1c1b6b95106adcea8ce54bcb59'
                    }
                },
                {
                    'sys_id': {
                        'display_value': 'f445676edbe5e1108394816404961901',
                        'value': 'f445676edbe5e1108394816404961901'
                    },
                    'u_sector': {
                        'display_value': 'Gerência',
                        'link': 'https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/d72d983d1b65211060d9426fe54bcbff',
                        'value': 'd72d983d1b65211060d9426fe54bcbff'
                    },
                    'u_user.email': {
                        'display_value': 'qualquercoisa@arrobaemail.com.br',
                        'value': 'qualquercoisa@arrobaemail.com.br'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    },
                    'u_location': {
                        'display_value': 'PE - Hospital São Marcos',
                        'link': 'https://rdsldev.service-now.com/api/now/table/cmn_location/075ab5fe1bfa7810bcd687bfe54bcb00',
                        'value': '075ab5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'u_profile': {
                        'display_value': 'Location Manager',
                        'value': 'location_manager'
                    },
                    'u_user': {
                        'display_value': 'Guilherme Oliveira de Carvalho',
                        'link': 'https://rdsldev.service-now.com/api/now/table/sys_user/e1b2ce641b8099504e95a68fe54bcbbc',
                        'value': 'e1b2ce641b8099504e95a68fe54bcbbc'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.all_paginate_v2('0', '10'), 
        'method': 'GET', 
        'data':  [
            {
                "sys_id":"6e075a721bae7110081287bfe54bcb25",
                "name":"Indicadores Indicadores",
                "u_active":"true",
                "u_user_id":"eab5db981be3d5104e95a68fe54bcbbe",
                "u_user_email":"qualquercoisa@arrobaemail.com.br",
                "u_profile":"Gestor da unidade",
                "u_locations":[]
            },
            {
              "sys_id": "3d53335d1b1571909cac32681b4bcbdc",
              "name": "Adegil Henrique Miguel da Silva",
              "u_active": "true",
              "u_user_id": "ef887a001b0eb4106adcea8ce54bcb10",
              "u_user_email" : "qualquercoisa@arrobaemail.com.br",
              "u_profile": "Gestor da unidade",
              "u_locations": []
            },
            {
              "sys_id": "25537fdd1b5df550d83e0dcbe54bcb6b",
              "name": "Adelino Vieira da Silva Neto",
              "u_active": "true",
              "u_user_id": "890620311b97dd504e95a68fe54bcbd9",
              "u_user_email" : "qualquercoisa@arrobaemail.com.br",
              "u_profile": "Gestor da unidade",
              "u_locations": []
            },
            {
              "sys_id": "ef9a98ab1b6d71504e95a68fe54bcbd3",
              "name": "ADRIANA MARQUES",
              "u_active": "true",
              "u_user_id": "f68832841b06f4104e95a68fe54bcbd1",
              "u_user_email" : "qualquercoisa@arrobaemail.com.br",
              "u_profile": "Gestor da unidade",
              "u_locations": []
            },
            {
              "sys_id": "c405a86f1b25f1506adcea8ce54bcbde",
              "name": "Adriani Goulart",
              "u_active": "true",
              "u_user_id": "7a08b2041b06f4104e95a68fe54bcb67",
              "u_user_email" : "qualquercoisa@arrobaemail.com.br",
              "u_profile": "Gestor da unidade",
              "u_locations": []
            },
            {
              "sys_id": "104933581b413d909cac32681b4bcb6f",
              "name": "ADRIANO ROMANI",
              "u_active": "true",
              "u_user_id": "cf883a001b0eb4106adcea8ce54bcb49",
              "u_user_email" : "qualquercoisa@arrobaemail.com.br",
              "u_profile": "Gestor da unidade",
              "u_locations": []
            },
            {
              "sys_id": "634220231b61b1504e95a68fe54bcb9b",
              "name": "Alair Freitas",
              "u_active": "true",
              "u_user_id": "a408328c1bcab4106adcea8ce54bcbb1",
              "u_user_email" : "qualquercoisa@arrobaemail.com.br",
              "u_profile": "Gestor da unidade",
              "u_locations": []
            },
            {
              "sys_id": "770406f01bc57d14d83e0dcbe54bcb56",
              "name": "ALAN Braga Pereira",
              "u_active": "true",
              "u_user_id": "1308f2041b06f4104e95a68fe54bcb3b",
              "u_user_email" : "qualquercoisa@arrobaemail.com.br",
              "u_profile": "Gestor da unidade",
              "u_locations": []
            },
            {
              "sys_id": "660cd0e787a1fd50f230a6c30cbb350d",
              "name": "Aldenir da Silva Pereira",
              "u_active": "true",
              "u_user_id": "5d5876441b06f4104e95a68fe54bcba4",
              "u_user_email" : "qualquercoisa@arrobaemail.com.br",
              "u_profile": "Gestor da unidade",
              "u_locations": []
            },
            {
              "sys_id": "c5c1ecaf1b217d104e8c98e13a4bcb3b",
              "name": "ALEX Abrantes Da Silva Verdini",
              "u_active": "true",
              "u_user_id": "0748b6cc1bcab4106adcea8ce54bcb8e",
              "u_user_email" : "qualquercoisa@arrobaemail.com.br",
              "u_profile": "Gestor da unidade",
              "u_locations": []
            }
          ]
    },
]